import React from 'react';
import { categories } from '../mock';
import { ArrowUpRight } from 'lucide-react';
import SectionHeader from './SectionHeader';
import useReveal from '../hooks/useReveal';

export default function CategoryGrid() {
  const [ref, visible] = useReveal();
  return (
    <section
      id="shop"
      ref={ref}
      className={`max-w-7xl mx-auto px-3 sm:px-4 md:px-6 py-12 sm:py-16 md:py-24 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
    >
      <div className="mb-8 md:mb-14 flex flex-col items-center px-1">
        <SectionHeader
          eyebrow="Curated For You"
          title="Shop By Category"
          subtitle="Handpicked collections for every mood, moment, and season."
        />
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2.5 sm:gap-4 md:gap-6">
        {categories.map((c, idx) => (
          <a
            key={c.id}
            href={c.href}
            className="group relative block overflow-hidden rounded-md shadow-sm hover:shadow-xl transition-shadow"
            style={{
              animationDelay: `${idx * 80}ms`,
              background: `radial-gradient(80% 55% at 50% 35%, ${c.accent || '#C9A961'}55 0%, transparent 60%), linear-gradient(180deg, #2a3344 0%, #1A2332 55%, #121820 100%)`,
            }}
          >
            <div className="aspect-[3/4] relative overflow-hidden flex items-end justify-center pt-6 pb-[38%]">
              <div
                className="absolute left-1/2 bottom-[36%] -translate-x-1/2 w-[55%] h-6 rounded-[100%] blur-xl opacity-50 pointer-events-none"
                style={{ background: '#000' }}
              />
              {visible ? (
                <img
                  src={c.image}
                  alt={c.title}
                  width={480}
                  height={640}
                  loading="lazy"
                  decoding="async"
                  className="relative z-[1] h-[72%] w-auto max-w-[78%] object-contain object-bottom drop-shadow-2xl group-hover:scale-105 transition-transform duration-[900ms]"
                />
              ) : null}
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent pointer-events-none" />
            <div className="absolute top-2 left-2 sm:top-3 sm:left-3 w-6 h-6 sm:w-8 sm:h-8 border-l border-t border-[#C9A961] opacity-70" />
            <div className="absolute top-2 right-2 sm:top-3 sm:right-3 w-6 h-6 sm:w-8 sm:h-8 border-r border-t border-[#C9A961] opacity-70" />
            <div className="absolute bottom-0 left-0 right-0 p-3 sm:p-4 md:p-6 text-[#F5EFE6] z-[2]">
              <h3 className="font-serif-display text-base sm:text-xl md:text-2xl mb-0.5 sm:mb-1 tracking-wide leading-tight">
                {c.title}
              </h3>
              <p className="text-[9px] sm:text-[11px] md:text-xs opacity-90 tracking-widest uppercase line-clamp-2">
                {c.subtitle}
              </p>
              <div className="mt-2 sm:mt-4 inline-flex items-center gap-1 text-[9px] sm:text-[10px] tracking-[0.2em] sm:tracking-[0.3em] uppercase border-b border-[#F5EFE6]/40 pb-0.5 group-hover:border-[#C9A961] group-hover:text-[#C9A961] transition-colors">
                View All <ArrowUpRight className="w-3 h-3 sm:w-3.5 sm:h-3.5" />
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
